













interface LocalProps {
  value: PropOptions;
  inputValue: PropOptions;
  styleType: PropOptions<StyleType>;
}

export default {
  name: 'HMCheckBoxGroupStudent',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: String,
      default: null,
    },
    styleType: {
      type: String,
      default: 'circle',
    },
  } as LocalProps,
  data() {
    return {
      inputModel: this.inputValue,
    };
  },
};
